/**
 * "A level is in progress" as one shared, global fact -- `PWA-042` needs this
 * definition and is explicit that it must be the same one `PROG-005` and
 * `PROG-033` already use, not a second one invented for this stage.
 *
 * `Play.tsx`'s own mounting effect already tracks exactly this, privately, as
 * its closure-local `torn` flag: false from the moment a level actually
 * mounts (past the resume-offer and discard-warning screens, which are not
 * "in progress" -- nothing is playing yet) until the level ends by any
 * means (`onComplete`) or the effect tears down (leaving the screen). This
 * signal is written at exactly those same three points and nowhere else, so
 * it can never drift from what `persistInProgress`'s own guard already
 * decides in the same file.
 */

import { signal } from '@preact/signals';

export const levelInProgressSignal = signal(false);
